import { CirclePlus } from 'lucide-react';
import { useState } from 'react';

import { type ParentDetails } from '~entities/parent';
import { useUpdateParentByStudentId } from '~entities/parent/api/update-parent-by-student-id';

import {
  EmergencyContactForm,
  type EmergencyContactFormSchema,
} from '~features/contacts/parent/emergency-contact-form';

import { cn } from '~shared/shadcn/lib/utils';
import { Button } from '~shared/shadcn/ui/button';
import { Card } from '~shared/shadcn/ui/card';

export function AddEmergencyContact({
  // contact,
  parent,
  studentId,
}: {
  parent: ParentDetails;
  // contact: EmergencyContact;
  studentId: string;
}) {
  const [isEditing, setIsEditing] = useState(false);

  const { mutateAsync: updateParent, isPending } = useUpdateParentByStudentId();

  const onSubmit = async (data: EmergencyContactFormSchema) => {
    try {
      // Only send the emergency contacts array - partial update
      const updatedEmergencyContacts = [...parent.emergencyContacts, data];

      await updateParent({
        studentId: studentId,
        parentId: parent._id,
        parent: {
          emergencyContacts: updatedEmergencyContacts,
        },
      });
      setIsEditing(false);
    } catch (error) {
      console.error('Failed to update parent:', error);
    }
  };

  if (isEditing) {
    return (
      <div className='max-w-sm'>
        <EmergencyContactForm
          setIsEditing={setIsEditing}
          onSubmit={onSubmit}
          isPending={isPending}
        />
      </div>
    );
  }

  return (
    <div className='max-w-sm'>
      <Card
        className={cn(
          'flex h-full flex-1 flex-col rounded-[1.25rem] p-6 text-card-foreground shadow-none',
        )}
      >
        <div className='flex flex-1 items-center justify-center'>
          <Button
            className={cn('h-fit p-1')}
            variant='ghost'
            onClick={() => {
              setIsEditing(true);
            }}
          >
            <CirclePlus className='mr-3' />
            <span className='font-semibold'>Add Emergency Contact</span>
          </Button>
        </div>
      </Card>
    </div>
  );
}
